import React from "react";
import { Box, FormLabel, Typography } from "@material-ui/core";

import { User } from "../../../../../../../../../../components/user/user.component";
import { makeKey } from "../../../../../../../../../../utils/helpers";

import { FlyerDetailPageFormPositionMerchOwnersProps } from "./flyer-detail-page-form-position-merch-owners.props";

export const FlyerDetailPageFormPositionMerchOwners = (
  props: FlyerDetailPageFormPositionMerchOwnersProps
) => (
  <>
    <label>
      <Box display="flex" justifyContent="space-between">
        <FormLabel component="h3">Merch Owners</FormLabel>
      </Box>
    </label>
    {props.merchOwners.map((merchOwner, index) => (
      <User key={makeKey("merchOwner", index)} user={merchOwner} />
    ))}
    {props.merchOwners.length === 0 && <Typography>No Merch Owners assigned</Typography>}
  </>
);
